export interface BlogPostMeta {
  slug: string
  title: string
  description: string
  date: string
  coverImage?: string
}

export const posts: BlogPostMeta[] = [
  {
    slug: 'reinvent-2025-software-practices',
    title: 'What re:Invent 2025 Changed About How I Build Software',
    description:
      'Practical AWS and AI engineering patterns that accelerate delivery, improve reliability, and reduce cost within 90 days.',
    date: '2025-12-05',
    coverImage: '/aws-reinvent.jpg',
  },
]
